import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  InputGroup,
  Popover,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { niceDateTime } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { withRouter } from "react-router";
import {
  DateInput,
  DateRangeInput,
  DateTimePicker,
} from "@blueprintjs/datetime";
// import DateTimePicker from "react-datetime-picker";
class KeyEvents extends React.Component {
  state = {
    collapsed: true,
    selectedDate: new Date(),
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }
  events = [
    "Arrival",
    "Admission",
    "Block Room",
    "Anaesthesia Start",
    "Surgery Start",
    "Surgery End",
    "Anaesthesia End",
    "Moved To Ward",
    "Discharge",
    "Patient Medication",
  ];
  renderEventsTimeline = () => {
    return this.events.map((each) => {
      let ll = this.props.data.keyEvents;
      let idx = _.findIndex(ll, (l) => l.event === each);
      if (idx > -1) {
        return (
          <ControlGroup style={{ marginTop: "5px" }}>
            <Tag
              large
              intent="success"
              minimal
              icon="endorsed"
              onRemove={() => {
                let filteredEvents = ll.filter((item, index) => index !== idx);

                this.props.onUpdate({ keyEvents: filteredEvents });
              }}
            >
              {each}
            </Tag>
            <Tag large intent="primary" icon="time">
              {niceDateTime(ll[idx].ts)}
            </Tag>
            <Tag large minimal>
              Notes
            </Tag>
            <InputGroup
              value={ll[idx].notes}
              onChange={(event) => {
                ll[idx].notes = event.target.value;
                this.props.onUpdate({ keyEvents: ll });
              }}
            />
          </ControlGroup>
        );
      } else {
        return (
          <ControlGroup style={{ marginTop: "5px" }}>
            <Tag large intent="warning" minimal>
              {each}
            </Tag>

            {/* <DateInput
              formatDate={(date) => date.toLocaleString()}
              parseDate={(str) => new Date(str)}
              onChange={(date) => {
                ll.push({
                  event: each,
                  ts: date,
                  notes: "",
                });
                this.props.onUpdate({ keyEvents: ll });
              }}
            /> */}
            <Popover
              captureDismiss={true}
              onClose={() => {
                ll.push({
                  event: each,
                  ts: this.state.selectedDate,
                  notes: "",
                });
                this.props.onUpdate({ keyEvents: ll });
              }}
              content={
                <DateTimePicker
                  // value={new Date()}
                  onChange={(date) => {
                    this.setState({ selectedDate: date });
                    // ll.push({
                    //   event: each,
                    //   ts: date,
                    //   notes: "",
                    // });
                    // this.setState({ keyEvents: ll });
                  }}

                  // value={value}
                />
              }
            >
              {/* select data time button */}
              <Button outlined text="Select Date and Time"></Button>
            </Popover>
            {/* <div>
             
            </div> */}
            {/* <Button
              outlined
              text="Mark Done Now"
              onClick={() => {
                ll.push({
                  event: each,
                  ts: new Date(),
                  notes: "",
                });
                this.props.onUpdate({ keyEvents: ll });
              }}
            /> */}
          </ControlGroup>
        );
      }
    });
  };

  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Key Events
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>{" "}
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Key Events
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {
                      display: "flex",
                      flexDirection: "row",
                      // alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <div>{this.renderEventsTimeline()}</div>
              <div>
                <ControlGroup>
                  <Tag minimal large>
                    OT Number
                  </Tag>
                  <InputGroup
                    style={{ width: "6em" }}
                    value={
                      this.props.data?.keyEvents?.find(
                        (l) => l.event === "Admission"
                      )
                        ? this.props.data.keyEvents.find(
                            (l) => l.event === "Admission"
                          ).notes
                        : ""
                    }
                    onChange={(event) => {
                      console.log(
                        this.props.data.keyEvents.find(
                          (l) => l.event === "Admission"
                        )
                      );

                      this.props.data.keyEvents.find(
                        (l) => l.event === "Admission"
                      ).notes = event.target.value;
                      this.props.onUpdate({
                        keyEvents: this.props.data.keyEvents,
                      });
                    }}
                  />
                </ControlGroup>
                <ControlGroup style={{ marginTop: "1rem" }}>
                  <Tag minimal large>
                    Case Number
                  </Tag>
                  <InputGroup
                    style={{ width: "6em" }}
                    value={this.props.data?.caseNumber || ""}
                    onChange={(event) => {
                      this.props.onUpdate({
                        caseNumber: event.target.value,
                      });
                    }}
                  />
                </ControlGroup>
              </div>
            </div>
            <br />
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(KeyEvents)));
